<p-fieldset legend="Licitantes com CNPJ">
  <div class="row">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="licitanteAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm">
    <thead>
      <tr>
        <th scope="col">CNPJ</th>
        <th scope="col">Razão Social</th>
        <th scope="col">Sócio</th>
        <th scope="col">Administrador</th>
        <th scope="col">EPP</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of entidade?.Licitante?.LicitanteCNPJ">
        <td>
          {{item.CNPJ | CPF}}
        </td>
        <td>
          {{item.RazaoSocial}}
        </td>
        <td>
          <span *ngIf="item.LicitanteSocio?.tipoDoc === 'CNPJ'">{{item.LicitanteSocio.CNPJ | CPF}}</span>
          <span *ngIf="item.LicitanteSocio?.tipoDoc === 'CPF'">{{item.LicitanteSocio.CPF | CPF}}</span>
          <span *ngIf="item.LicitanteSocio?.tipoDoc === 'OUTRO'">{{item.LicitanteSocio.OutroDoc}}</span>
        </td>
        <td>
          {{item.LicitanteAdministrador | CPF}}
        </td>
        <td>
          {{item.LicitanteDeclaracaoMicroEmpresaPequenoPorte}}
        </td>

        <td class="text-right">
          <button (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>

<div class="modal fade" id="dialogLicitanteCNPJ" data-backdrop="static" data-keyboard="false" tabindex="-1"
  role="dialog" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg" role="document">
    <div class="modal-content" *ngIf="licitanteAtual">
      <div class="modal-header bg-primary text-white">
        Licitante com CNPJ
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-4">
            <label class="required">CNPJ</label>
            <input type="text" class="form-control" [(ngModel)]="licitanteAtual.CNPJ"
              [ngModelOptions]="{standalone: true}" [imask]="{mask: '00.000.000/0000-00'}" unmask="true">
          </div>
          <div class="col-md-8">
            <label class="required">Razão Social</label>
            <input type="text" class="form-control" [(ngModel)]="licitanteAtual.RazaoSocial"
              [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-md-4">
            <label>CPF Administrador</label>
            <input type="text" class="form-control" [(ngModel)]="licitanteAtual.LicitanteAdministrador"
              [ngModelOptions]="{standalone: true}" [imask]="{mask: '000.000.000-00'}" unmask="true">
          </div>
          <div class="col-md-8">
            <label class="d-block">Sócio</label>
            <select class="form-control col-4 float-left" [(ngModel)]="licitanteAtual.LicitanteSocio.tipoDoc"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesDoc" [ngValue]="item">{{item}}</option>
            </select>
            <input *ngIf="licitanteAtual.LicitanteSocio?.tipoDoc === 'CPF'" type="text"
              class="form-control col-8 float-right" [(ngModel)]="licitanteAtual.LicitanteSocio.CPF"
              [ngModelOptions]="{standalone: true}" [imask]="{mask: '000.000.000-00'}" unmask="true">
            <input *ngIf="licitanteAtual.LicitanteSocio?.tipoDoc === 'CNPJ'" type="text"
              class="form-control col-8 float-right" [(ngModel)]="licitanteAtual.LicitanteSocio.CNPJ"
              [ngModelOptions]="{standalone: true}" [imask]="{mask: '00.000.000/0000-00'}" unmask="true">
            <input *ngIf="licitanteAtual.LicitanteSocio?.tipoDoc === 'OUTRO'" type="text"
              class="form-control col-8 float-right" [(ngModel)]="licitanteAtual.LicitanteSocio.OutroDoc"
              [ngModelOptions]="{standalone: true}">
          </div>
        </div>
        <div class="row mt-2">
          <label class="required col-9 col-form-label">
            Licitante apresentou declaração de Microempresa ou Empresa de Pequeno Porte?
          </label>
          <p-selectButton [options]="opcoesSimNao" optionValue="id" class="col-3 pt-1"
            [(ngModel)]="licitanteAtual.LicitanteDeclaracaoMicroEmpresaPequenoPorte"
            [ngModelOptions]="{standalone: true}">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </div>
        <div class="row mt-2" *ngIf="entidade.modalidade === 4">
          <div class="col-12">
            <label class="required">Identificação do Participante</label>
            <select class="form-control" [(ngModel)]="licitanteAtual.IdentificacaoLicitante"
              [ngModelOptions]="{standalone: true}">
              <option *ngFor="let item of opcoesLicitante" [ngValue]="item.id">{{item.nome}}</option>
            </select>
          </div>
        </div>
        <lib-licitacao-audesp-licitante-item [licitante]="licitanteAtual" [lotes]="listaLotes">
        </lib-licitacao-audesp-licitante-item>
      </div>
      <div class="modal-footer">
        <button (click)="salvar()" class="btn btn-sm btn-primary mr-2">
          Salvar
        </button>
        <button (click)="cancelar()" class="btn btn-sm btn-link mr-2 text-muted">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>